import React from 'react'
import '../styles.css'


export default function ProductSection(props){
    const direction = props.direction;
    
    
    return(
        <div id = "product-section" style = {{display: "flex", flexDirection: direction }}>
            <div id = "product-desc-container">
                <p id = "desc-title">{props.desctitle}</p>
                <p id = "product-desc">{props.description}</p>
            </div>
            <div id = "img-container">
                <img id= 'desc-img' src = {props.imgURL} alt = 'img'></img>
            </div>
        </div>
    )
}